import React, { ReactDOM, PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* Third party tools */
import MobileDetect from 'mobile-detect'

import selector from './selector'

/* Assets */
import logo from 'assets/logo_transparent.png'
import brandLogo from 'assets/mpura_logo.png'

/* Styles */
import './styles.css'

/* Actions */
import {
  login,
  requestPasswordResetToken,
} from 'react-redux/actions/user'

import { setView } from 'react-redux/actions/app'
import * as VIEW from 'component/app/view'

/* Login Component like used on the landing page */
class Login extends Component {

  constructor(props) {
    super(props)
    this.state = {
      passwordReset: false,
      email: "",
      password: ""
    }
  }

  componentDidMount() {
    this.emailInput.focus() // set cursor to emailInput field
  }

  setMail(e) {
    this.setState({email: e.target.value})
  }

  setPassword(e) {
    this.password = e.target.value
    this.setState({password: e.target.value})
  }

  onSubmit(e) {
    e.preventDefault() // Don't execute event default
    e.stopPropagation() // Stop Event from bubbling
    this.login()
  }

  onPasswordReset(e) {
    const { requestPasswordResetToken } = this.props
    e.preventDefault() // Don't execute event default
    e.stopPropagation() // Stop Event from bubbling
    requestPasswordResetToken(this.state.email)
    this.setState({passwordReset: true})
  }

  onImprintClick(e) {
    const { setView } = this.props
    setView(VIEW.IMPRINT)
  }

  login() {
    const { login } = this.props
    login(this.state.email, this.state.password)
  }

  /* show background video on non mobile devices */
  renderVideo() {
    const { brand } = this.props
    if (brand.logo === "light-instruments") {
      var isMobile = new MobileDetect(window.navigator.userAgent).mobile()
      if (!isMobile) return <iframe style={{position: 'absolute'}} width="100%" height="100%" src={ "https://www.youtube.com/embed/videoseries?list=PLeQO4poQjLW10wcsyukyKc4TYBw0zaN-z&autoplay=1&showinfo=0&controls=0&loop=1&mute=1&iv_load_policy=3&modestbranding=0&volume=0" } frameBorder="0" allowFullScreen="true"/>
    }
    return null
  }

  renderPasswordResetNotificaiton() {
    if( !this.state.passwordReset) return
    const { t } = this.props
    return (
      <div className="login-error">{ t('user:login.passwordResetMessage') }</div>
    )
  }

  /* render error if necessary */
  renderPasswordReset() {
    const { t, error } = this.props
    if (error && this.state.email) return (
      <button className="warning password-reset" onClick={ this.onPasswordReset.bind(this) }>{ t('user:login.passwordReset') }</button>
    )
    return null
  }

  /* render error if necessary */
  renderError() {
      const { t, error, errorText } = this.props
      if (error) return (
        <div className="login-error">{ t('user:login.message.'+errorText) }</div>
      )
      return null
  }

  isChrome() {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }

  renderChromeMessage() {
    const { t } = this.props
    if(!this.isChrome()) return (
      <div className="chrome-message">{ t('user:login.chromeMessage') } <a href="https://www.google.com/chrome/" target="blank">Download Google Chrome</a></div>
    )
    return null
  }

  renderImprint() {
    const { t } = this.props
    return (
      <div className="imprint"><a
        className="imprint-link"
        onClick={ this.onImprintClick.bind(this) }
      >
        { t('app:imprintLink') }
      </a></div>
    )
    return null
  }

  renderForm() {
    if( this.state.passwordReset) return
    const { t } = this.props
    return (
      <form onSubmit={ this.onSubmit.bind(this) }>
        <input
          type="email"
          value={ this.state.email }
          ref={ (c) => this.emailInput = c }
          placeholder={ t("user:login.emailInput.placeholder") }
          defaultValue={ this.email }
          onChange={ this.setMail.bind(this) }
        />
        <input
          type="password"
          value={ this.state.password }
          placeholder={ t("user:login.passwordInput.placeholder") }
          defaultValue={ this.password }
          onChange={ this.setPassword.bind(this) }
        />
        <button
          type="submit"
          className="action"
        >
          { t("user:login.loginButtonLabel") }
        </button>
        { this.renderPasswordReset() }
        { this.renderError() }
        { this.renderChromeMessage() }
        { this.renderImprint() }
      </form>
    )
  }

  renderLogo() {
    const { t, brand } = this.props
    switch (brand.logo) {
      case "mpura":
        return <img
          className="brand-logo"
          src={ brandLogo }
        />
      default:
        return <img
         className="logo"
         src={ logo }
         alt={ t('user:login.logoAlt') }
         title={ t('user:login.logoTitle') }
       />
    }
  }


  render() {
    const { t } = this.props
    return <div className="login component">
      { this.renderVideo() }
      <div className="wrapper form">
        <div className="logo-wrapper">
          { this.renderLogo() }
        </div>
        { this.renderForm() }
        { this.renderPasswordResetNotificaiton() }
      </div>
    </div>
  }
}

Login.propTypes = {}

function mapStateToProps(state){
    return selector(state)
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            login,
            requestPasswordResetToken,
            setView
        },
        dispatch
    )
}

const reduxComponent = connect(mapStateToProps, mapDispatchToProps)(Login)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/login/index.js